import { render, staticRenderFns } from "./Bumenfeiyonghuizongbiao.vue?vue&type=template&id=50e9a247&scoped=true&"
import script from "./Bumenfeiyonghuizongbiao.vue?vue&type=script&lang=js&"
export * from "./Bumenfeiyonghuizongbiao.vue?vue&type=script&lang=js&"
import style0 from "./Bumenfeiyonghuizongbiao.vue?vue&type=style&index=0&id=50e9a247&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e9a247",
  null
  
)

export default component.exports